import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Analytics tracking hook for funnel events
 * 
 * Supported events:
 * - landing_page_view
 * - dba_check_started
 * - dba_question_answered
 * - dba_check_completed
 * - premium_cta_clicked
 * - payment_success
 * - premium_report_viewed
 */

export const trackEvent = async (eventType, submissionId = null, metadata = {}) => {
  try {
    await axios.post(`${API_URL}/analytics/event`, {
      event_type: eventType,
      submission_id: submissionId,
      metadata: metadata,
      user_agent: navigator.userAgent,
      referrer: document.referrer || null
    });
  } catch (error) {
    // Silently fail - analytics should not break the app
    console.debug('Analytics event failed:', eventType, error);
  }
};

// Convenience functions for each event type
export const analytics = {
  landingPageView: () => trackEvent('landing_page_view'),
  
  dbaCheckStarted: () => trackEvent('dba_check_started'),
  
  dbaQuestionAnswered: (submissionId, questionId, questionNumber) => 
    trackEvent('dba_question_answered', submissionId, { 
      question_id: questionId,
      question_number: questionNumber 
    }),
  
  dbaCheckCompleted: (submissionId, score, outcome) => 
    trackEvent('dba_check_completed', submissionId, { 
      score, 
      outcome 
    }),
  
  premiumCtaClicked: (submissionId, ctaType = 'save_results') => 
    trackEvent('premium_cta_clicked', submissionId, { 
      cta_type: ctaType 
    }),
  
  paymentSuccess: (submissionId, amount) => 
    trackEvent('payment_success', submissionId, { 
      amount 
    }),
  
  premiumReportViewed: (submissionId) => 
    trackEvent('premium_report_viewed', submissionId)
};

export default analytics;
